/** Compact one-liner for mobile — text before the em-dash, without trailing period. */
export const getSlideShortBody = (body: string): string =>
  body.split('—')[0].trim().replace(/\.$/, '');
